import { MESSAGE_DETAIL_ACTIONS } from '../constants/actionsConstants';

const initialState = {
  messageDetail: null,
  allMessages: [],
  error: null
};

const messageRemindersReducer = (state = initialState, action) => {
  switch (action.type) {
    case MESSAGE_DETAIL_ACTIONS.PROCESS_MESSAGE_REQUEST:
      return { ...state, error: null };
    case MESSAGE_DETAIL_ACTIONS.PROCESS_MESSAGE_SUCCESS:
      return {
        ...state,
        messageDetail: action.payload,
        error: null
      };
    case MESSAGE_DETAIL_ACTIONS.PROCESS_MESSAGE_FAILURE:
      return {
        ...state,
        error: action.payload,
        messageDetail: null
      };
    default:
      return state;
  }
};

export default messageRemindersReducer;
